import type { Entry, EntrySkeletonType, EntryFieldTypes } from 'contentful'

import type { ColorStyleType } from '@constants/enums/color'

export enum ComponentLinkTargetTab {
  Self = 'Current ( _self )',
  Blank = 'New ( _blank )',
}

export enum ComponentLinkRelType {
  Canonical = 'canonical',
  External = 'external',
  NoFollow = 'nofollow',
  NoOpener = 'noopener',
  NoReferrer = 'noreferrer',
}

export interface TypeComponentLinkFields {
  internalName: EntryFieldTypes.Symbol
  targetUrl: EntryFieldTypes.Text
  title?: EntryFieldTypes.Symbol
  targetTab?: EntryFieldTypes.Symbol
  relationToUrl?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>
  appendCurrentQueryParams?: EntryFieldTypes.Boolean
  showArrow?: EntryFieldTypes.Boolean
  colorStyle?: EntryFieldTypes.Symbol<ColorStyleType>
  embeddedEntryText?: EntryFieldTypes.Symbol
}

export type TypeComponentLinkSkeleton = EntrySkeletonType<TypeComponentLinkFields, 'componentLink'>
export type TypeComponentLinkEntry = Entry<
  TypeComponentLinkSkeleton,
  'WITHOUT_UNRESOLVABLE_LINKS',
  'en-US'
>
